export default "__VITE_ASSET__BiQpeTnE__"